import React from 'react';
import LazyLoad from 'react-lazyload';
import { Element } from 'react-scroll';
import '../../../log2base2.css';
import {
  FocusContainer,
  FeatureContainerTitle,
  FeatureContainer,
  ReverseFeatureContainer,
  FeatureContent,
  FeatureTitle,
  FeatureSubTitle,
  FeatureDescription,
  FeatureAnimation,
  Video,
  FeatureContainerTitleText,
} from './styles';

const Features = ({ cloudFront, variant }) => (
  <Element name="learningFeatures" id="learningFeatures">
    <FocusContainer>
      {variant === 'regionals' || variant === 'partner-plus' || variant === 'code-juniors' ? (
        <FeatureContainerTitleText variant={variant}>See why learners choose us</FeatureContainerTitleText>
      ) : (
        <FeatureContainerTitle>See why learners choose us</FeatureContainerTitle>
      )}

      <FeatureContainer>
        <FeatureContent>
          <FeatureSubTitle>CODE WALKTHROUGH</FeatureSubTitle>
          <FeatureTitle>
            Visualize{' '}
            <span
              className={`${
                variant === 'partner-plus' ? 'partnerPlusTxt' : variant === 'regionals' ? 'regionalsDarkTxt' : variant === 'code-juniors' ? 'codeJuniorsTxt' : 'brandTxt'
              } headingFont`}
            >
              step by step
            </span>{' '}
            code execution
          </FeatureTitle>
          <FeatureDescription>
            With our step-by-step code walkthrough, you can visualize what happens in the computer memory when each and every line of code executes.
          </FeatureDescription>
        </FeatureContent>
        <FeatureAnimation>
          <LazyLoad offset={0}>
            <object className="no-pointers" data={cloudFront + '/Assets/homePage/FeaturePreviewVisualizeNew.svg'}>
              Feature Preview
            </object>
          </LazyLoad>
        </FeatureAnimation>
      </FeatureContainer>

      <ReverseFeatureContainer>
        <FeatureAnimation>
          <LazyLoad offset={0}>
            <object className="no-pointers" data={cloudFront + '/Assets/homePage/FeaturePreviewRealTimeNew.svg'}>
              Feature Preview
            </object>
          </LazyLoad>
        </FeatureAnimation>
        <FeatureContent>
          <FeatureSubTitle marginLeft={true}>LEARN FASTER</FeatureSubTitle>
          <FeatureTitle marginLeft={true}>
            Learn coding in a{' '}
            <span
              className={`${
                variant === 'partner-plus' ? 'partnerPlusTxt' : variant === 'regionals' ? 'regionalsDarkTxt' : variant === 'code-juniors' ? 'codeJuniorsTxt' : 'brandTxt'
              } headingFont`}
            >
              fun & faster
            </span>{' '}
            way
          </FeatureTitle>
          <FeatureDescription marginLeft={true}>
            Important and complex topics are connected to real-life events which will make the learning fun and you will remember it forever.
          </FeatureDescription>
        </FeatureContent>
      </ReverseFeatureContainer>

      <FeatureContainer>
        <FeatureContent>
          <FeatureSubTitle>QUALITY CONTENT</FeatureSubTitle>
          <FeatureTitle>
            Our contents are curated by top{' '}
            <span
              className={`${
                variant === 'partner-plus' ? 'partnerPlusTxt' : variant === 'regionals' ? 'regionalsDarkTxt' : variant === 'code-juniors' ? 'codeJuniorsTxt' : 'brandTxt'
              } headingFont`}
            >
              industry experts
            </span>
          </FeatureTitle>
          <FeatureDescription>We handpick content from top-notch industry experts & convert it into highly engaging visual videos with the help of animation.</FeatureDescription>
        </FeatureContent>
        <FeatureAnimation>
          <LazyLoad offset={0}>
            <object className="no-pointers" data={cloudFront + '/Assets/homePage/FeaturePreviewCompaniesTransparent.svg'}>
              Feature Preview
            </object>
          </LazyLoad>
        </FeatureAnimation>
      </FeatureContainer>
    </FocusContainer>
  </Element>
);

export default Features;
